<template>
  <apexchart
    v-if="overallChartOptions"
    type="area"
    height="320"
    :options.sync="overallChartOptions"
    :series.sync="overallSeries"
  ></apexchart>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "dashboard",
  props: ["data", "overallChartOptions"],
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    overallSeries: [
      {
        name: "Num of Students",
        data: []
      }
    ]
  }),
  async mounted() {
    this.initGraph();
  },
  methods: {
    async initGraph() {
      this.overallSeries = [
        {
          data: this.data,
          name: "Num of Students"
        }
      ];
    }
  },
  watch: {
    data() {
      this.initGraph();
    }
  }
};
</script>

<style scoped>
.apexcharts-text.apexcharts-yaxis-label > tspan {
  font-size: 12px;
}
</style>
